import { render, staticRenderFns } from "./StartBox.vue?vue&type=template&id=730009e3&scoped=true&"
import script from "./StartBox.vue?vue&type=script&lang=js&"
export * from "./StartBox.vue?vue&type=script&lang=js&"
import style0 from "./StartBox.vue?vue&type=style&index=0&id=730009e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730009e3",
  null
  
)

export default component.exports